'use strict';
import {RouterStateError} from '../app/enums';


export const TASK_STATE_HELPER = {
  resolveProject: ['$stateParams', 'ProjectDomain', 'currentUser', resolveProject],
  resolveAssetProject: ['$stateParams', 'AssetProjectDomain', 'currentUser', resolveAssetProject],
  resolveMilestone: ['$stateParams', 'MilestoneDomain', 'currentUser', resolveMilestone],
  createResolveTask: createResolveTask,
  resolveRequirementType: ['$stateParams', resolveRequirementType],
  createResolveRequirement: createResolveRequirement,
};

function resolveProject($stateParams, ProjectDomain) {
  if ($stateParams.projectId) {
    return ProjectDomain.$get($stateParams.projectId);
  } else {
    return null;
  }
}

function resolveAssetProject($stateParams, AssetProjectDomain) {
  if ($stateParams.assetProjectId) {
    return AssetProjectDomain.$get($stateParams.assetProjectId);
  } else {
    return null;
  }
}

function resolveMilestone($stateParams, MilestoneDomain) {
  if ($stateParams.milestoneId) {
    return MilestoneDomain.$get($stateParams.milestoneId);
  } else {
    return null;
  }
}

function createResolveTask(domainClass, taskListState) {
  return [
    '$stateParams',
    domainClass,
    'currentUser',
    resolveTask];

  function resolveTask($stateParams, TaskDomain) {
    if ($stateParams.taskId) {
      return TaskDomain.$get($stateParams.taskId).then(function (task) {
        if (task) {
          return task;
        } else {
          return __taskFailed();
        }
      }, __taskFailed);
    } else {
      return __taskFailed();
    }
  }

  function __taskFailed() {
    return Promise.reject({
      code: RouterStateError.NO_DATA,
      messageId: 'state.no.task.message',
      fallback: taskListState,
    });
  }
}

function resolveRequirementType($stateParams) {
  return $stateParams.requirementType || null;
}

function createResolveRequirement(domainClass, taskListState) {
  return [
    '$stateParams',
    domainClass,
    'currentUser',
    resolveRequirement];

  function resolveRequirement($stateParams, RequirementDomain) {
    if ($stateParams.requirementId) {
      return RequirementDomain.$get($stateParams.requirementId).then(function (req) {
        if (req) {
          return req;
        } else {
          return __reqFailed();
        }
      }, __reqFailed);
    } else {
      return __reqFailed();
    }
  }

  function __reqFailed() {
    return Promise.reject({
      code: RouterStateError.NO_DATA,
      messageId: 'state.no.requirement.message',
      fallback: taskListState,
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/TASK_STATE_HELPER.js